import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import arraddinput from "../../../ArrAddInput/index";
import { updateConfig as _updateConfig, listConfig } from '@/api/configurationlist';
import { cloneDeep, isEqual } from 'lodash';
export default {
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      loading: true,
      WatchData: {
        name: []
      },
      data: {}
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler() {
        this.getConfig();
      }
    }
  },
  components: {
    arraddinput: arraddinput
  },
  methods: {
    // 获取配置参数
    getConfig: function getConfig() {
      var _this = this;

      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "string",
        config: "filter",
        lists: [{
          list: "name"
        }]
      }]).then(function (res) {
        var data = res.data.data.mess[0];

        _this.$set(_this.data, "name", data.s_objects[0].lists.name);

        _this.WatchData = cloneDeep(_this.data);
        _this.loading = false;
      }).catch(function (err) {
        _this.$message({
          message: _this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    updateConfig: function updateConfig() {
      var _this2 = this;

      if (!isEqual(this.data, this.WatchData)) {
        var data = {}; //筛选为空的参数

        for (var key in this.WatchData) {
          data[key] = this.WatchData[key];
        }

        _updateConfig(this.deviceSn, this.deviceDid, [{
          section: "string",
          config: "filter",
          action: 0,
          index: [0],
          server: 'filter',
          lists: {
            name: data.name
          }
        }]).then(function (res) {
          if (res.data.data.mess === 0) {
            //重启防护墙
            _updateConfig(_this2.deviceSn, _this2.deviceDid, [{
              section: "string",
              config: "filter",
              action: 0,
              index: [0],
              server: 'firewall',
              lists: {
                name: data.name
              }
            }]).then(function (res) {
              _this2.$message({
                showClose: true,
                message: _this2.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: 'success'
              });

              _this2.getConfig();
            });
          } else {
            _this2.$message({
              showClose: true,
              message: _this2.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });

            return;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    },
    GetArrList: function GetArrList(props) {
      this.data.name = props;
    }
  }
};